import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { getTonnes, maxProducts } from '../util/helpers'

const sumWeight = (spots, type) => spots.reduce((acc, spot) => {
    if (!spot.products?.length) return acc
    return acc + spot.products.reduce((prodAcc, curr) => {
        if (!curr.product?.weight) return prodAcc
        if (type && curr.product.packagingType !== type) return prodAcc
        return prodAcc + curr.product.weight
    }, 0)
}, 0)

const getTotalWeight = (spots) => `${getTonnes(sumWeight(spots))} t`

const getWeightByType = (spots, type) => `${getTonnes(sumWeight(spots, type))} t`

const getTotalSpots = (spots) => {
    const total = spots.reduce((acc, spot) => acc + (spot.maxProducts ? spot.maxProducts : maxProducts), 0)
    const occupied = spots.reduce((acc, spot) => acc + (spot.products?.length ? spot.products.length : 0), 0)

    return `${occupied} / ${total}`
}

const getLabResult = (spots) => `${spots.reduce((acc, spot) => acc + (spot.currentLabResult ? 1 : 0), 0)} / ${spots.length}`

const Stats = ({
    warehouse,
}) => {
    const { t } = useTranslation()

    if (!warehouse) return <></>
    
    return (
        <div className="stats">
            <div className='stats-row'>
                <span>{ t('stats.spots') }</span>
                <span>{ getTotalSpots(warehouse.spots) }</span>
            </div>
            <div className='stats-row'>
                <span>{ t('stats.weight') }</span>
                <span>{ getTotalWeight(warehouse.spots) }</span>
            </div>
            <div className='stats-row'>
                <span>{ t('stats.weight_bigbag') }</span>
                <span>{ getWeightByType(warehouse.spots, 'BIGBAG') }</span>
            </div>
            <div className='stats-row'>
                <span>{ t('stats.weight_sb25') }</span>
                <span>{ getWeightByType(warehouse.spots, 'SB25') }</span>
            </div>
            <div className='stats-row'>
                <span>{ t('stats.weight_sb50') }</span>
                <span>{ getWeightByType(warehouse.spots, 'SB50') }</span>
            </div>
            <div className='stats-row'>
                <span>{ t('stats.lab_results') }</span>
                <span>{ getLabResult(warehouse.spots) }</span>
            </div>
        </div>
    )
}

Stats.propTypes = {
    warehouse: PropTypes.object.isRequired,
}

export default Stats